'use strict';

const axios = require('axios');

module.exports = (couponData) => {
    return {
        namespaced: true,
        state: {
            ...couponData,
            errorMessage: ''
        },
        getters: {},
        actions: {
            addCoupon({state, commit, dispatch}, couponCodeValue) {
                const bodyFormData = new FormData();
                bodyFormData.append(state.couponCsrfName, state.couponCsrfToken);
                bodyFormData.append(state.couponInputName, couponCodeValue);
                bodyFormData.append(state.addCouponAction, state.addCouponAction);
                bodyFormData.append(state.resources.isCheckoutPage, true);

                return axios({
                    method: 'post',
                    url: state.couponSubmitURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then((result) => {
                    commit('setErrorMessage', result.data.errorMessage || '');
                    if (!result.data.errorMessage) {
                        commit('setCodeValue', couponCodeValue);
                        commit('setPriceAdjustment', result.data.couponData.priceAdjustment);
                        commit('setRemoveAction', result.data.couponData.removeCouponAction);
                        commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {
                            root: true
                        });
                        dispatch('payments/setGiftCardData', result.data.giftCardData, { root: true });
                    }
                    return !result.data.errorMessage;
                });
            },
            removeCoupon({state, commit, dispatch}) {
                const bodyFormData = new FormData();
                bodyFormData.append(state.couponInputName, state.couponCodeValue);
                bodyFormData.append(state.removeCouponAction, state.removeCouponAction);

                return axios({
                    method: 'post',
                    url: state.couponSubmitURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then((result) => {
                    if (result.data) {
                        commit('setCodeValue', '');
                        commit('setRemoveAction', '');
                        commit('setPriceAdjustment', '');
                        commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {
                            root: true
                        });
                        dispatch('payments/setGiftCardData', result.data.giftCardData, { root: true });
                    }
                    return !!result.data;
                });
            }
        },
        mutations: {
            setErrorMessage(state, newMessage) {
                state.errorMessage = newMessage;
            },
            setCodeValue(state, couponCodeValue) {
                state.couponCodeValue = couponCodeValue;
            },
            setRemoveAction(state, action) {
                state.removeCouponAction = action;
            },
            setPriceAdjustment(state, priceAdjustment) {
                state.priceAdjustment = priceAdjustment;
            }
        }
    };
};
